const formatRupiah = (value) => `${Number(value).toLocaleString("id-ID")}`;

const toCleanNumber = (val) => {
    if (val === null || val === undefined) return 0;
    if (typeof val === "number") return val;
    return parseFloat(String(val).replace(/[^0-9.-]/g, "")) || 0;
};

const parseDataChart = (data) => {
    const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];

    const dataChart = months.map(m => ({ division: m }));

    data.forEach(item => {
        Object.entries(item.totalPriceType || {}).forEach(([month, price]) => {
            const index = parseInt(month, 10) - 1;
            const numeric = toCleanNumber(price);

            dataChart[index][item.typeName] = numeric;
        });
    });

    return dataChart;
};

const parseDataKey = (data) => {
    let dataKey = [];
    data.map((item, index) => {
        // dataKey[index] = {key: item.typeName, color: generateLightHexColor(index, data.length)}
        dataKey[index] = {key: item.typeName, color: generateReadableColor(index, data.length)}
    });
    return dataKey;
};

function generateLightHexColor(index = 0, total = 20) {
    const hue = (index * (360 / total)) % 360; // ensures color distribution
    const saturation = 60 + Math.random() * 20; // 60–80%
    const lightness = 75 + Math.random() * 10;  // 75–85%

    // Convert HSL to hex
    return hslToHex(hue, saturation, lightness);
}

function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const k = n => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = n =>
        Math.round(255 * (l - a * Math.max(Math.min(k(n) - 3, 9 - k(n), 1), -1)))
            .toString(16)
            .padStart(2, '0');
    return `#${f(0)}${f(8)}${f(4)}`;
}

function generateReadableColor(index = 0, total = 20) {
    const hue = (index * (360 / total)) % 360;  // evenly spaced hues
    const saturation = 70;                      // keep color vivid
    const lightness = 65;                       // avoid dark tones

    return hslToHex(hue, saturation, lightness);
}

export const service = {
    parseDataChart,
    parseDataKey,
};